<template>
  <div class="location-picker" v-click-outside="doHideDropdown">
    <div class="dropdown" :class="{'show': showDropdown}">
      <button
        class="btn btn-primary btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded="false"
        ref="Dropdown"
        @click="doShowDropdown"
      >{{$t('local_picker.area.name')}}: {{locationName}}</button>
      <div class="dropdown-menu dropdown-menu-right" :class="{'show': showDropdown}">
        <div class="container-fluid">
          <div class="row">
            <div class="col-6">
              <div class="head">{{$t('local_picker.area.location')}}:</div>
              <div class="option-list">
                <div
                  class="selection-wraper"
                >
                  <button
                    type="button"
                    class="btn"
                    :class="{'btn-outline-secondary': (selectedProvince), 'btn-primary': (selectedProvince == null)}"
                    @click="selectProvince(null, null)"
                  >{{$t('all')}}</button>
                </div>
                <div
                  class="selection-wraper"
                  v-for="(province, key) in Provinces"
                  :key="key"
                >
                  <button
                    type="button"
                    class="btn"
                    :class="{'btn-outline-secondary': (key!==selectedProvinceId), 'btn-primary': (key==selectedProvinceId)}"
                    @click="selectProvince(province, key)"
                  >{{province.name}}</button>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="head">{{$t('local_picker.area.area')}}</div>
              <div class="option-list">
                <div v-if="selectedProvince">
                  <div
                    class="selection-wraper"
                    v-for="(district, key) in selectedProvince.districts"
                    :key="key"
                  >
                    <button
                      type="button"
                      class="btn"
                      :class="{'btn-outline-secondary': (key!==selectedDistrictId), 'btn-primary': (key==selectedDistrictId)}"
                      @click="selectDistrict(district, key)"
                    >{{district}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <button type="button" class="btn btn-outline-secondary col-12" @click="resetAll">{{$t('sort.btn_reset')}}</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-info col-12" @click="apply">{{$t('sort.btn_apply')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.location-picker {
  display: inline-block;
}
.dropdown-menu {
  min-width: 600px;
  -webkit-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  padding: 10px;
  .head {
    font-weight: bold;
    padding-bottom: 10px;
  }
  .selection-wraper {
    padding-bottom: 10px;
    button {
      font-size: 0.9em;
      font-weight: bold;
    }
  }
}
.option-list {
  max-height: 500px;
  overflow-y: scroll;
  // padding-left: 15px;
  padding-right: 15px;
  .btn.btn-outline-secondary {
    border-color: #e8e8e8;
  }
}

@media screen and (max-width: 320px){
  .option-list {
    max-height: 400px;
  }
}

@media screen and (min-width: 321px) and (max-width: 360px){
  .option-list {
    max-height: 490px;
  }
}

@media screen and (min-width: 361px) and (max-width: 375px){
  .option-list {
    max-height: 520px;
  }
}

@media screen and (min-width: 376px) and (max-width: 411px){
  .option-list {
    max-height: 545px;
  }
}

// @media screen and (min-width: 361px) and (max-width: 411px){
//   .option-list {
//     max-height: 590px;
//     background-color: blue;
//   }
// }

@media (max-width: 1023px) {
  .dropdown-menu {
    position: fixed;
    top: 15px;
    left: 15px;
    bottom: 15px;
    right: 15px;
    min-width: 100px;
  }
}
@media screen and (max-width: 375px) and (min-width: 361px){
  .dropdown-menu .option-list {
      max-height: 72vh !important;
  }
}

// @media (max-width: 991.98px) {
//   .dropdown-menu {
//     position: fixed;
//     top: 15px;
//     left: 15px;
//     bottom: 15px;
//     right: 15px;
//     min-width: 100px;
//   }
// }

</style>

<script>
import ClickOutside from "vue-click-outside";
import Provinces from "@/constants/provinces-vi.json";

export default {
  name: "OrderPicker",
  directives: { ClickOutside },
  data() {
    console.log(this.value);

    return {
      showDropdown: false,
      values: {},
      model: {},
      Provinces,
      selectedProvince: null,
      selectedProvinceId: null,
      selectedDistrict: null,
      selectedDistrictId: null
    };
  },
  props: {
    value: Object
  },
  computed: {
    locationName() {
      if (this.selectedDistrict) {
        return this.selectedDistrict;
      }
      return this.$t('all');
    }
  },
  methods: {
    doHideDropdown() {
      this.showDropdown = false;
    },
    doShowDropdown() {
      this.showDropdown = true;
    },
    resetAll() {
      this.selectDistrict(null, null);
      this.doHideDropdown();
      this.selectedProvince = null;
      this.selectedProvinceId = null;
      this.model = {
        districtId: this.selectedDistrictId
      };
      this.$emit("input", this.model);
    },
    selectProvince(province, key) {
      console.log('select province',province, key);
      
      this.selectedProvince = province;
      this.selectedProvinceId = key;
      if (province) {
        this.selectedDistrict = province.districts[0];
      }else{
        this.selectedDistrict = null;
      }
    },
    selectDistrict(district, key) {
      this.selectedDistrict = district;
      this.selectedDistrictId = key;
    },
    apply() {
      this.doHideDropdown();
      this.model = {
        districtId: this.selectedDistrictId
      };
      if(!this.selectedDistrict){
        this.model = {};
      }
      this.$emit("input", this.model);
    }
  },
  mounted() {
    // console.log(`Provinces`, this.Provinces);

    // const Dropdown = this.$refs.Dropdown;
    // $("body").on("click", function(e) {
    //   if (
    //     !$("li.dropdown.mega-dropdown").is(e.target) &&
    //     $("li.dropdown.mega-dropdown").has(e.target).length === 0 &&
    //     $(".open").has(e.target).length === 0
    //   ) {
    //     $("li.dropdown.mega-dropdown").removeClass("open");
    //   }
    // });
  }
};
</script>